
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/inventory/parker",
      function () {
        return require("private-next-pages/en/inventory/parker.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/inventory/parker"])
      });
    }
  